import { info } from '../../application/console'
import { queryString } from '../../utils/window'
import { getIsMobile } from '../../utils/ua'
import BaseClass from '../../application/BaseClass'
import { externalScriptsConfig } from '../../organizedByType/config/externalScripts'
import { external as externalScriptLoader } from '../../utils/script'
import {
  debug as debugHeaderBidder,
  HB_NAMESAPCE as headerBidderNameSpace,
  HB_MS_TIMEOUT as headerBidderTimeout,
} from '../../organizedByType/config/headerBidderScriptConfig'
import { getCountryCode, NO_LOCATION } from '../../providers/geolocationProvider'

const { debugAds } = queryString

function conditionallyAddHeaderBidderScript(countryCode) {
  const shouldLoadHeaderBidderScript = externalScriptsConfig.headerBidder.shouldLoad(countryCode)
  debugHeaderBidder('shouldLoadHeaderBidderScript', shouldLoadHeaderBidderScript)
  return shouldLoadHeaderBidderScript
    ? new Promise(function headerBidderIsLoadedPromiseResolver(resolve, reject) {
        window[headerBidderNameSpace] = {
          jsLoaded: externalScriptsConfig.headerBidder.afterLoad(
            resolve,
            countryCode,
            headerBidderTimeout
          ),
        }
        window[headerBidderNameSpace].pagetype = getIsMobile() ? 'mobile' : 'desktop'
        debugHeaderBidder(
          `window.${headerBidderNameSpace}.pagetype is set to:`,
          window[headerBidderNameSpace].pagetype
        )
        externalScriptLoader.load({
          ...externalScriptsConfig.headerBidder,
          loadNow: true,
        })
      })
    : countryCode
}

function loadDfpScript(callback) {
  return externalScriptLoader.load({
    name: externalScriptsConfig.dfp.name,
    loadNow: true,
  })(callback)
}

// Disabled because _base.html.slim has the script already.
function conditionallyAddDfpScript(countryCode, callback) {
  const shouldLoadDfpScript = externalScriptsConfig.dfp.beforeLoad()
  const callbackWithCountryCode = callback.bind(0, countryCode)
  return shouldLoadDfpScript ? loadDfpScript(callbackWithCountryCode) : callbackWithCountryCode()
}

export class DoubleClickProvider extends BaseClass {
  constructor(initAds) {
    super()
    getCountryCode()
      .then(conditionallyAddHeaderBidderScript)
      .then(countryCode => conditionallyAddDfpScript(countryCode, initAds))
      .catch(conditionallyAddDfpScript.bind(0, NO_LOCATION, initAds))
    debugAds && info('Initializing DoubleClickProvider with callback', initAds)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/ads/doubleClickProvider.js